import React from 'react'

const Printer = ({ color }) => {
    return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2829_12080)">
                <g clip-path="url(#clip1_2829_12080)">
                    <path d="M12.5547 24.2759V10.2327C12.5547 7.66203 14.278 5.57812 16.4037 5.57812H34.3366C33.1263 5.57812 32.1453 6.76445 32.1453 8.22789V24.276" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M34.6931 9.94914H36.3706V8.03867C36.3706 6.67977 35.4597 5.57812 34.3359 5.57812" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17.6953 10.8711H26.5707" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17.6953 15.0586H26.5707" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17.6953 19.5469H26.5707" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M34.6262 20.3281H37.3477C38.9023 20.3281 40.1627 21.5884 40.1627 23.1431V35.1328C40.1627 36.6875 38.9023 37.9478 37.3477 37.9478H7.77594C6.22125 37.9478 4.96094 36.6875 4.96094 35.1328V23.1431C4.96094 21.5884 6.22125 20.3281 7.77594 20.3281H10.2491" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.66406 24.2773H35.4613" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M34.3359 34.5898H35.4614" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M30.375 34.5898H31.5004" stroke={color} stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_2829_12080">
                    <rect width="40.9271" height="40.9271" fill={color} transform="translate(0.5625 0.507812)" />
                </clipPath>
                <clipPath id="clip1_2829_12080">
                    <rect width="40" height="40" fill={color} transform="translate(2.61719 1.71875)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default Printer